import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const StaticDataPage = () => {
  const [yearPhalan, setYearPhalan] = useState([]);
  useEffect(() => {
    axios.get('/data/60_years_phalan.json').then(r => setYearPhalan(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>📊 60 ஆண்டு பலன்கள்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>60 Year Cycle Data</div>
      </div>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.65rem'}}>
        <thead><tr style={{background:T.greenDk,color:'#fff'}}>
          <th style={{padding:'4px',border:'1px solid #ccc'}}>#</th>
          <th style={{padding:'4px',border:'1px solid #ccc'}}>ஆண்டு</th>
          <th style={{padding:'4px',border:'1px solid #ccc'}}>பலன்</th>
        </tr></thead>
        <tbody>{yearPhalan.map((y,i)=>(
          <tr key={i} style={{background:i%2?'#f5f5f5':'#fff'}}>
            <td style={{padding:'3px',border:'1px solid #eee',textAlign:'center'}}>{y.id||y.No||i+1}</td>
            <td style={{padding:'3px',border:'1px solid #eee',fontWeight:700,color:T.greenDk}}>{y.Year||y.YearName||y.name||''}</td>
            <td style={{padding:'3px',border:'1px solid #eee'}}>{y.Phalan||y.Result||y.phalan||''}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
};
export default StaticDataPage;